module.exports = __webpack_public_path__ + "packs/media/images/send_message_icon-2cbcd8ff11e81db5ee1e8e9ff2356302.png";